import styled from 'styled-components';

import { theme } from '@/lib';

const Toggle = styled.div`
  padding-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ._dark & {
    .form-item-label {
      margin-top: 0;
    }
    &.form-item-toggle .form-item-input {
      &.on {
        background: ${theme.clientColor.third};
      }
    }
  }

  &.form-item-toggle .form-item-input {
    width: 46px;
    height: 24px;
    background: #e1e1e1;
    border-radius: 18px;
    border: 0;
    padding: 2px;
    cursor: pointer;
    &::before {
      content: '';
      display: block;
      width: 20px;
      height: 20px;
      border-radius: 20px;
      background-color: #fff;
    }
    &.on {
      background: #6c6fff;
      &::before {
        float: right;
      }
    }
  }
`;

export default { Toggle };
